import * as React from "react";
function ArrowLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.57 21a.378.378 0 01-.253-.097L3.392 12.88a1.165 1.165 0 01-.382-.804A.339.339 0 013 12c0-.02.002-.038.005-.052v-.023c.02-.312.157-.599.387-.806l8.924-8.021a.378.378 0 01.541.034c.14.162.124.41-.034.553l-8.816 7.924h16.61c.211 0 .383.175.383.391a.387.387 0 01-.383.391H4.009l8.814 7.924c.16.143.175.39.035.553a.384.384 0 01-.288.132z"
  }));
}
const ForwardRef = React.forwardRef(ArrowLeftIcon);
export default ForwardRef;